var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicWandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1339_82646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4265 2.42678L13.5732 1.57344C13.4982 1.49766 13.4089 1.43749 13.3105 1.39643C13.2121 1.35537 13.1065 1.33423 12.9999 1.33423C12.8932 1.33423 12.7877 1.35537 12.6893 1.39643C12.5908 1.43749 12.5015 1.49766 12.4265 1.57344L1.5732 12.4268C1.49741 12.5018 1.43725 12.5911 1.39619 12.6895C1.35513 12.7879 1.33398 12.8935 1.33398 13.0001C1.33398 13.1067 1.35513 13.2123 1.39619 13.3107C1.43725 13.4091 1.49741 13.4984 1.5732 13.5734L2.42653 14.4268C2.50108 14.5034 2.59022 14.5643 2.6887 14.6058C2.78717 14.6474 2.89298 14.6688 2.99987 14.6688C3.10676 14.6688 3.21256 14.6474 3.31104 14.6058C3.40951 14.5643 3.49865 14.5034 3.5732 14.4268L14.4265 3.57344C14.5031 3.4989 14.564 3.40975 14.6056 3.31128C14.6472 3.21281 14.6686 3.107 14.6686 3.00011C14.6686 2.89322 14.6472 2.78741 14.6056 2.68894C14.564 2.59047 14.5031 2.50133 14.4265 2.42678Z",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 4.66675L11.3335 6.66675",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 4V6.66667",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 9.33325V11.9999",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 1.33325V2.66659",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 5.33325H2",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 10.6667H11.3335",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 2H6",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1339_82646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWandIcon);
export default __webpack_public_path__ + "static/media/magic-wand-icon.899edf3ecc7242961cca4f9d63a73063.svg";
export { ForwardRef as ReactComponent };